import React from "react";

export interface StepperNode {
  id: string;
  icon: React.ReactNode;
  /** Translated label, used by the active hero block under the stepper */
  title: string;
  /** Translated subtitle for active step */
  subtitle?: string;
  isRequired?: boolean;
}

interface WizardStepperHeaderProps {
  nodes: StepperNode[];
  currentIndex: number;
  /** Furthest index ever reached (controls which past steps are tappable) */
  reachedIndex: number;
  onJump: (index: number) => void;
}

/**
 * Horizontal 4-node stepper with gradient teal→blue active tile, check for
 * completed past steps, and a hero block (icon + title + subtitle) for the
 * current step. Purely presentational.
 */
export function WizardStepperHeader({
  nodes,
  currentIndex,
  reachedIndex,
  onJump,
}: WizardStepperHeaderProps) {
  const active = nodes[currentIndex];

  return (
    <div className="space-y-5">
      {/* Active step hero */}
      {active && (
        <div className="flex items-start gap-4">
          <div className="min-w-0 flex-1">
            <h3 className="text-xl md:text-2xl font-bold tracking-tight text-foreground flex items-center gap-1">
              {active.title}
              {active.isRequired && (
                <span className="text-[#E5574E] text-base">*</span>
              )}
            </h3>
            {active.subtitle && (
              <p className="text-sm text-muted-foreground mt-1">
                {active.subtitle}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
